// ignore-string-externalization
import { AccessTokenManager } from '@spotify-internal/access-token';
import { getSpotifyClientId } from '@mrkt/features/env';

// todo: remove dependency on creator-auth-proxy (probably move to mrkt.spotify.net?)
const accessTokenManager = new AccessTokenManager({
  url: `https://wgint.spotify.net/creator-auth-proxy/v1/web/token?client_id=${getSpotifyClientId()}`,
  options: { credentials: 'include' },
});

export const isSlingshot =
  typeof window === 'object' &&
  /^creator-mrkt-web-[0-9]+\.(slingshot-instance|services\.guc3)\.spotify\.net$/.test(
    window.location.hostname,
  );

export async function getSlingshotAuthToken() {
  const token = await accessTokenManager.get();
  return [token, 0] as const;
}
